module.exports = __webpack_public_path__ + "static/media/zaya_folding_arm.1d1f7760.gif";